import {updateMask} from '@js/utils/update-mask'

const carousel = {
	state:    {
		scrollTriggers: [],
		previousWidth:  0,
	},
	elements: {
		$fixedContactButton: $('.js-contact-fixed'),
		$carouselsContainer: $('.js-carousels'),
		$section:            $('.js-carousel'),
		$swiper:             $('.js-carousel-swiper'),
		$previousButton:     $('.js-carousel-previous'),
		$nextButton:         $('.js-carousel-next'),
	},

	selectors: {
		carousel:           '.js-carousel',
		pagination:         '.js-carousel-pagination',
		navigationNext:     '.js-carousel-next',
		navigationPrevious: '.js-carousel-previous',
		wrapperClass:       'js-carousel-slides',
		slideClass:         'js-carousel-slide',
		carouselMainImage:  '.js-carousel-main-image',
	},

	init() {
		this.initSwiper()

		this.initEvents()
	},

	initSwiper() {
		this.elements.$swiper.each((index, element) => {
			const $swiper = $(element)

			const swiper = new window.Swiper(element, {
				wrapperClass:   this.selectors.wrapperClass,
				slideClass:     this.selectors.slideClass,
				slidesPerView:  'auto',
				spaceBetween:   '10%',
				centeredSlides: true,
				breakpoints:    {
					1:    {
						slidesPerView:  1.1,
						spaceBetween:   '24px',
						centeredSlides: false,
					},
					768:  {
						slidesPerView: 2,
					},
					1024: {
						slidesPerView: 'auto',
					},
				},
				pagination:     {
					el:   $swiper.closest(this.selectors.carousel).find(this.selectors.pagination)[0],
					type: 'fraction',
				},
				navigation:     {
					nextEl: $swiper.closest(this.selectors.carousel).find(this.selectors.navigationNext)[0],
					prevEl: $swiper.closest(this.selectors.carousel).find(this.selectors.navigationPrevious)[0],
				},
			})

			$swiper.data('swiper', swiper)
		})
	},

	initMask() {
		this.elements.$section.each((index, element) => {
			const maskUrl = element.style.getPropertyValue('--section-mask-url').replace('url(\'#', '').replace('\')', '')

			window.gsap.timeline({
				defaults:      {
					ease: 'none',
				},
				scrollTrigger: {
					trigger:             element,
					start:               () => `${window.vh * 100} bottom`,
					end:                 () => `+=${window.vh * 200}`,
					scrub:               true,
					invalidateOnRefresh: true,
					onUpdate:            () => {
						updateMask(element.find(this.selectors.carouselMainImage), maskUrl)
					},
				},
			}).to(element, {
				'--carousel-progress': 1,
			})
		})
	},

	initEvents() {
		this.initMask()
	},
}

export default carousel
